export const get_query = stack => {
  if (stack) {
    let level = stack[stack.length - 1]
    let place = level[level.length - 1]
    let { payload: { search } = {} } = place
    return search
  }
}
